module.exports = __webpack_public_path__ + "static/media/textoeventos.17ccfd74.png";